module.exports = __webpack_public_path__ + "static/media/ad_manager_header_raw.c4a37efc.png";